import { cn } from "@/lib/utils"

/**
 * Pulsing placeholder block for loading layouts; size via className.
 *
 * @category Feedback
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  )
}

export { Skeleton }
